module.exports = __webpack_public_path__ + "static/img/item_j_wildberry.8261641.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item_j_wildberry.png
// module id = LNIF
// module chunks = 1